// External dependencies
import React from 'react';

// Internal dependencies
import StudentVideo from '../StudentVideo';

export default class Video extends React.Component {
  constructor (props){
    super(props);
    this.state = {
      playing: false,
    };
  }

  componentDidMount(){
    if(this.props.playVideo){
      this.playVideo();
    }
  }

  componentDidUpdate(prevProps){
    if(!prevProps.playVideo && this.props.playVideo){
      this.playVideo();
    }
    if(prevProps.videoURL != this.props.videoURL){
      this.playVideo();
    }
  }
  playVideo(){
    this.setState({
      playing: true,
    });
  }

  onDone(){
    this.setState({playing: false});
    if(this.props.onDone){
      this.props.onDone()
    }
  }

  render() {
    return (
      <div className="dyslexiaVideoPlayerContainer">
        <div className="dyslexiaVideoPlayer outlined">
          <StudentVideo {...this.props} onDone={this.onDone.bind(this)} key="theOnlyStudentVideoPlayer" autoPlay={this.state.playing} speech={this.props.speech}/>
        </div>
      </div>
    );
  }
}
